/**
 * Code for MSH Community Preference
 */
import $ from "jquery";
var communityPreferenceContainer = $("#secCommunityPreferences");
if (communityPreferenceContainer && communityPreferenceContainer.length > 0) {
    InitCommunityPreferenceEvents();
}

function InitCommunityPreferenceEvents() {
    // State Dropdown Event
    var stateFilter = $("#state-filter");
    if (stateFilter && stateFilter.length > 0) {
        stateFilter.on("change", function () {
            $.ajax({
                url: '/communitypreference/filtercommunity',
                data: { stateCode: $(this).val() },
                success: function (resp) {
                    if (resp) {
                        if (resp.Success) {
                            $('#divCommunitiesSelection').html(resp.Data.Html);

                            // Reinitialize Script dependencies after postback
                            $("#CommunityList").foundation();
                            $('.interest-list-options').click(function (e) {
                                e.preventDefault();
                                var divHeight = $('.contact-interest-area').height() - 45;
                                $('.selected-aside').css('max-height', divHeight + 'px');
                                $('.selected-aside').addClass('show');
                            });

                            // Check if the community is already selected.
                            $("#divSelectedCommunityList > a").each(function (index) {
                                $("." + $(this).attr("communityGuid")).addClass("select");
                            });

                            // Hide ddlStateCP validator parent
                            $("#rfvCommunities").parents(".form-input-container").hide();

                            if ($(".interest-list-accordion > .accordion-item > a").length == "1") {
                                // expand it automatically
                                $(".interest-list-accordion > .accordion-item > a")[0].click();
                            }
                        }
                    }
                }
            });
        });
    }

    // Submit Event
    var submitButton = $("#submit-community");
    if (submitButton && submitButton.length > 0) {
        submitButton.on("click", function (e) {
            e.preventDefault();
            postInterestList();
        });
    }
}

function AddNewCommunity(communityGuid, communityName, stateCode, city) {
    if ($("#selected-" + communityGuid).length > 0) {
        // do something here
    }
    else {
        $("#divSelectedCommunityList").append('<a href="javascript:void(0);" class="interest-list-options close" communityGuid="' + communityGuid + '" community="' + communityName + '" id="selected-' + communityGuid + '" onclick="RemoveCommunity(\'' + communityGuid + '\')">' + communityName + ', ' + city + ', ' + stateCode + '</a>');
        $("." + communityGuid).addClass("select");
    }
}

function RemoveCommunity(communityGuid) {
    $("." + communityGuid).removeClass("select");
    $("#selected-" + communityGuid).remove();
}

function postInterestList() {
    var adId = $("#hfadId").val();
    var oldCommunities = $("#hfOldCommunities").val();
    var selectedCommunities = "";

    $("#divSelectedCommunityList > a").each(function (index) {
        if (selectedCommunities == "") {
            selectedCommunities = selectedCommunities + $(this).attr("community");
        }
        else {
            selectedCommunities = selectedCommunities + "," + $(this).attr("community");
        }
    });

    $.ajax({
        method: "POST",
        url: '/communitypreference/submitcommunities/',
        data: { adId: adId, oldCommunities: oldCommunities, selectedCommunities: selectedCommunities },
        beforeSend: function () {
            window.showPreLoader();
        },
        success: function (resp) {
            if (resp) {
                if (resp.Success) {
                    $("#hfOldCommunities").val(resp.OldCommunitiesString);
                    $("#communityPreferenceConfirmation").removeClass("hide");
                }
            }
        },
        complete: function () {
            window.hidePreLoader();
        }
    });
}

function addErrorClass(validator) {
    $("#" + validator.id).parents(".form-input-container").addClass("has-error");
    $("#" + validator.id).removeAttr("style");
    $("#" + validator.id + " > p").attr("aria-hidden", "false");
}

function removeErrorClass(validator) {
    $("#" + validator.id).parents(".form-input-container").removeClass("has-error");
    $("#" + validator.id + " > p").attr("aria-hidden", "true");
}

window.AddNewCommunity = AddNewCommunity;
window.RemoveCommunity = RemoveCommunity;
